// The transforSAPId is exported in helpers,
// to have the core logic available without react component
// e.g. for tables, there is no need to be wrapping in an additional dom node.
import { transformSAPId } from 'utils/helpers';

export default ({ children, originalId }) => children(transformSAPId({ originalId }));
